export const suggestedSkills = [
    'Adobe InDesign',
    'Adobe Lightroom',
    'Adobe Premiere',
    'Adobe XD',
    'Asana',
    'AutoCAD',
    'Axure',
    'Blockchain',
    'Braze',
    'Bubble.io',
    'Buffer',
    'C++',
    'Canva',
    'Constant Contact',
    'Cryptography',
    'CSS',
    'DAOs',
    'DeFi',
    'Discord',
    'Domo',
    'Eloqua',
    'Ethereum',
    'ExactTarget',
    'Figma',
    'Github',
    'Google AdSense',
    'Google Analytics',
    'Google Data Studio',
    'Google Doc',
    'Google Sheet',
    'Google Slides',
    'Greenhouse',
    'Hootsuite',
    'HTML',
    'Hubspot',
    'Illustrator',
    'InVision',
    'Java',
    'Javascript',
    'Jira',
    'jQuery',
    'Later',
    'LinkedIn',
    'Mailchimp',
    'Marketo',
    'Microsoft Excel',
    'Microsoft PowerPoint',
    'Microsoft Word',
    'MongoDB',
    'MySQL',
    'NetSuite',
    'NFTs',
    'Notion',
    'Objective-C',
    'Oracle',
    'Origami',
    'Pardot',
    'Photoshop',
    'Planoly',
    'Python',
    'Qualtrics',
    'R',
    'React',
    'Rust',
    'Sales Navigator',
    'Salesforce',
    'Scala',
    'Scratch',
    'Shopify',
    'Slack',
    'Solana',
    'Solidity',
    'Solidworks',
    'SQL',
    'Swift',
    'Tableau',
    'Telegram',
    'Web3JS',
    'Webflow',
    'Workday',
    'Zendesk'
];
